import NewUsersSocial from "../NewUserClass/NewUsersSocial";
import { Card, CardBody, Col } from "reactstrap";
import JasonBorneMessage from "../NewUserClass/JasonBorneMessage";
import IssaBellMessage from "../NewUserClass/IssaBellMessage";
import CommentsBox from "../NewUserClass/CommentsBox";
import LikeContent from "../NewUserClass/LikeContent";
import { Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { Href, MoreCommnets } from "../../../../../Constant";

const NewUserClass2 = () => {
  return (
    <Col sm="12">
      <Card>
        <CardBody>
          <NewUsersSocial />
          <Image className="img-fluid" alt="user12" src={dynamicImage("social-app/timeline-2.png")}/>
          <div className="timeline-content">
            <P>The only way to do something in depth is to work hard. I've always thought of the T-shirt as the Alpha of the fashion alphabet. My breakfast is very important. Everything I do is a matter of heart, body and soul.</P>
            <LikeContent />
            <div className="social-chat">
              <JasonBorneMessage />
              <IssaBellMessage />
              <div className="text-center">
                <a href={Href}>{MoreCommnets}</a>
              </div>
            </div>
            <CommentsBox/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default NewUserClass2;
